import { resources } from '@api'
import MainContainer from '@blocks/MainContainer'
import { notify, route } from '@helpers'
import useTitle from '@hooks/useTitle'
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import SalonForm from '../Form'

export default function SalonAdd() {
    const history = useHistory()
    useTitle("Salon: Add")

    const handleSuccess = () => {
        notify("Thank you, the salon was created.")
        history.push(route("admin:salons"))    
    }

    return (
        <MainContainer heading={<><Link to={route("admin:salons")}>Salons</Link> — Add</>}>
            <SalonForm 
                method="post"
                url={resources.salons}
                handleSuccess={handleSuccess} />
        </MainContainer>
    )
}